export default {
  DASHBOARD_ROUTE: {
    PARENT: "admin/",
    ROUTE: "dashboard",
  },
  USERS_ROUTE: {
    PARENT: "admin/",
    ROUTE: "users",
  },
  AUCTION_ROUTE: {
    PARENT: "admin/",
    ROUTE: "auction",
  },
  TERMS_AND_CONDITIONS_ROUTE: {
    PARENT: "admin/",
    ROUTE: "terms-and-conditions",
  },
  BALANCE_WITHDRAW_ROUTE: {
    PARENT: "admin/",
    ROUTE: "balance-withdraw",
  },
  PAYMENT_CONTROL_ROUTE: {
    PARENT: "admin/",
    ROUTE: "payment-control",
  },
  TRANSACTIONS_ROUTE: {
    PARENT: "admin/",
    ROUTE: "transactions",
  },
};
